/**
 * Rotação de mensagens do bloco de anúncio com fade in/out.
 * Lógica autocontida: encontra containers .announcement-messages e alterna os slides.
 */
(function () {
  const SLIDE_SELECTOR = '.announcement-messages__slide';
  const CONTAINER_SELECTOR = '.announcement-messages';
  const VISIBLE_CLASS = 'is-visible';

  function init(container) {
    if (container.dataset.announcementInited === '1') return;
    const slides = container.querySelectorAll(SLIDE_SELECTOR);
    if (slides.length < 2) return;
    container.dataset.announcementInited = '1';

    const speedSec = Number(container.dataset.speed) || 5;
    const intervalMs = speedSec * 1000;
    let index = 0;

    function showSlide(i) {
      slides.forEach((slide, idx) => {
        slide.classList.toggle(VISIBLE_CLASS, idx === i);
        slide.setAttribute('aria-hidden', idx !== i);
      });
    }

    function next() {
      index = (index + 1) % slides.length;
      showSlide(index);
    }

    showSlide(0);

    let tid = setInterval(next, intervalMs);

    container.addEventListener('mouseenter', () => {
      clearInterval(tid);
      tid = null;
    });
    container.addEventListener('mouseleave', () => {
      if (tid === null) {
        tid = setInterval(next, intervalMs);
      }
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearInterval(tid);
        tid = null;
      } else if (tid === null) {
        tid = setInterval(next, intervalMs);
      }
    });
  }

  function run() {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
